import React from "react";
import styled from "styled-components";

import * as T from "./Typography";
import * as I from "./Icons";
import * as UserContext from "./UserContext";
import * as u from "../utils";
import Button from "./Button";
import BusinessCard from "./BusinessCard";
import DropdownRow from "./Profile/DropdownRow.tsx";

export default function MembersCarousel(props) {
  const userInfo = React.useContext(UserContext.Context);
  const carouselRef = React.useRef(null);
  if (!userInfo.id || !props?.members?.length) return null;

  const [canScroll, setCanScroll] = React.useState({
    left: false,
    right: true,
  });
  React.useEffect(() => {
    getCanScroll();
  }, [carouselRef]);

  return (
    <>
      <T.CS>{props.subtitle}</T.CS>
      <DropdownRow
        maxHeight={320}
        maxMobileHeight={300}
        title={props.title}
        noGap
        divider
      >
        <S.MembersCarousel
          onScroll={getCanScroll}
          ref={carouselRef}
          data-cy={props.datacy}
        >
          <S.LeftArrow
            canScroll={canScroll.left}
            onClick={() => scrollCarousel(-300)}
          >
            <I.Arrow />
          </S.LeftArrow>
          {props.members.map((member) => (
            <BusinessCard key={member?.id} member={member} />
          ))}
          <S.RightArrow
            canScroll={canScroll.right}
            onClick={() => scrollCarousel(300)}
          >
            <I.Arrow />
          </S.RightArrow>
        </S.MembersCarousel>
      </DropdownRow>
    </>
  );

  function getCanScroll() {
    if (!carouselRef.current) return;
    const carousel = carouselRef.current;
    const canScrollLeft = carousel.scrollLeft !== 0;
    const canScrollRight =
      carousel.scrollLeft !== carousel.scrollWidth - carousel.clientWidth;
    setCanScroll({ left: canScrollLeft, right: canScrollRight });

    if (
      props.onLoadMembers &&
      props.members.length >= 30 &&
      canScrollLeft &&
      !canScrollRight
    ) {
      props.onLoadMembers();
    }
  }
  function scrollCarousel(distance) {
    carouselRef.current.scrollBy({ left: distance, behavior: "smooth" });
  }
}

const S = {};

S.MembersCarousel = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
  height: 300px;
  margin: 25px -16px;
  padding: 0 16px;
  > div {
    flex-shrink: 0;
  }
  -ms-overflow-style: none; /* IE 11 */
  scrollbar-width: none; /* Firefox 64 */
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    height: 0px;
    width: 0px;
  }
  @media ${u.device.tablet} {
    gap: 22px;
  }

  @supports not (-webkit-touch-callout: none) {
    overflow-x: auto;
    overflow-y: hidden;
  }
`;

S.Button = styled(Button)`
  height: 41px;
  margin-top: 5px;
`;

S.LeftArrow = styled.div`
  align-items: center;
  background: white;
  border: 1px solid ${u.colours.shellOverlay};
  border-radius: 25px;
  display: none;
  height: 32px;
  justify-content: center;
  left: 4px;
  margin-right: 0px;
  opacity: ${(p) => (p.canScroll ? "1" : "0")};
  position: sticky;
  transform: rotate(180deg);
  transition: all 0.2s ease-out;
  width: 32px;
  z-index: 2;
  ${(p) =>
    p.canScroll &&
    `:hover {
      cursor: pointer;
      background: rgb(200, 200, 200);
      border: 1px solid rgb(200, 200, 200);
    }`}
  @media (min-width: 520px) {
    display: flex;
  }
  @media ${u.device.tablet} {
    left: 24px;
  }
`;

S.RightArrow = styled.div`
  align-items: center;
  background: white;
  border: 1px solid ${u.colours.shellOverlay};
  border-radius: 25px;
  display: none;
  height: 32px;
  justify-content: center;
  margin-right: 0px;
  opacity: ${(p) => (p.canScroll ? "1" : "0")};
  position: sticky;
  right: 4px;
  transition: all 0.2s ease-out;
  width: 32px;
  z-index: 2;
  ${(p) =>
    p.canScroll &&
    `:hover {
    cursor:  pointer;
    background: rgb(200, 200, 200);
    border: 1px solid rgb(200, 200, 200);
  }`}
  @media (min-width: 520px) {
    display: flex;
  }
  @media ${u.device.tablet} {
    right: 24px;
  }
`;
